import { createStore } from 'vuex';
import helper from './modules/helper';
import page from './modules/page';
import user from './modules/user';
import layout from './modules/layout';

export default createStore({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    helper,
    page,
    user,
    layout,
  },
});
